import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getListData: {},
    enableDisableData: {},
    updatePasswordData: {},
    createData: {},
    updateData: {}, getAllModulePermissionData: {}, updateModulePermissionData: {},
    updatePasswordSellerData: {},
    changePasswordData: {},
    approveDisapproveData: {}, getAdminUserListData: {}, getAdminAddressListData: {}, getUsersListData: {},
    getSellerAllDocumentsData: {}
}

export const getList = createApiThunkPrivate('getList', '/admin-users/buyerList', 'GET', true)
export const enableDisable = createApiThunkPrivate('enableDisable', '/admin-users/enableDisable', 'PUT')
export const updatePassword = createApiThunkPrivate('updatePassword', '/admin-users/updatePassword', 'PUT')
export const create = createApiThunkPrivate('create', '/admin-users/create')
export const update = createApiThunkPrivate('update', '/admin-users/update', 'PUT')
export const getAllModulePermission = createApiThunkPrivate('getAllModulePermission', '/admin-users/getAllModulePermission', 'GET', true)
export const updateModulePermission = createApiThunkPrivate('updateModulePermission', '/admin-users/updateModulePermission', 'PUT')
export const getAllModulePermissionForUser = createApiThunkPrivate('getAllModulePermissionForUser', '/admin-users/getAllModulePermission', 'GET', true)


export const getAdminUserList = createApiThunkPrivate('getAdminUserList', '/admin-users/getList', 'GET', true)
export const getAdminAddressList = createApiThunkPrivate('getAdminAddressList', '/address/getList', 'GET', true)
export const getUsersList = createApiThunkPrivate('getUsersList', '/user/users-list', 'GET', true)


//sellers//
export const getSellerList = createApiThunkPrivate('getSellerList', '/seller/getList', 'GET')
export const enableDisableSeller = createApiThunkPrivate('enableDisableSeller', '/seller/enableDisable', 'PUT')
export const createSeller = createApiThunkPrivate('createSeller', '/seller/create')
export const updateSeller = createApiThunkPrivate('updateSeller', '/seller/update', 'PUT')
export const updatePasswordSeller = createApiThunkPrivate('updatePasswordSeller', '/seller/updatePassword', 'PUT')
export const changePassword = createApiThunkPrivate('changePassword', '/auth/changePassword', 'PUT')
export const approveDisapprove = createApiThunkPrivate('approveDisapprove', '/seller/approveDisapprove', 'PUT')



export const getSellerAllDocuments = createApiThunkPrivate('getSellerAllDocuments', '/seller/getAllDocuments', 'GET')

export const getSellerChatList = createApiThunkPrivate('getSellerChatList', '/seller/getChatList', 'GET')



const countrySlice = createSlice({
    name: 'user',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getList, 'getListData')
        createExtraReducersForThunk(builder, enableDisable, 'enableDisableData')
        createExtraReducersForThunk(builder, updatePassword, 'updatePasswordData')
        createExtraReducersForThunk(builder, create, 'createData')
        createExtraReducersForThunk(builder, update, 'updateData')
        createExtraReducersForThunk(builder, getAllModulePermission, 'getAllModulePermissionData')
        createExtraReducersForThunk(builder, updateModulePermission, 'updateModulePermissionData')
        createExtraReducersForThunk(builder, getSellerList, 'getSellerListData')
        createExtraReducersForThunk(builder, enableDisableSeller, 'enableDisableSellerData')
        createExtraReducersForThunk(builder, createSeller, 'createSellerData')
        createExtraReducersForThunk(builder, updateSeller, 'updateSellerData')
        createExtraReducersForThunk(builder, getAllModulePermissionForUser, 'getAllModulePermissionForUserData')
        createExtraReducersForThunk(builder, updatePasswordSeller, 'updatePasswordSellerData')
        createExtraReducersForThunk(builder, changePassword, 'changePasswordData')
        createExtraReducersForThunk(builder, approveDisapprove, 'approveDisapproveData')
        createExtraReducersForThunk(builder, getAdminUserList, 'getAdminUserListData')
        createExtraReducersForThunk(builder, getAdminAddressList, 'getAdminAddressListData')
        createExtraReducersForThunk(builder, getUsersList, 'getUsersListData')
        createExtraReducersForThunk(builder, getSellerAllDocuments, 'getSellerAllDocumentsData')
        createExtraReducersForThunk(builder, getSellerChatList, 'getSellerChatListData')




    }
})

export default countrySlice.reducer